import JsCookies from 'js-cookie';

// For cookies, Rails encodes the space " " character with "+" rather than "%20".
// The built-in converter in `js-cookie` recognizes only "%20" as an encoded space character.
// Therefore, it needs to be augmented to also recognize "+" encoded spaces.
// See also https://github.com/js-cookie/js-cookie#converters
export const Cookies = JsCookies.withConverter({
  read(value, name) {
    return JsCookies.converter.read(value.replaceAll('+', ' '), name);
  },
}).withAttributes({
  domain: window.location.hostname.replace(/^[^.]+/, ''), // e.g. ".kula.ai"
});

function getRedirectData() {
  const data = Cookies.get('redirect_data');
  try {
    return data && JSON.parse(data);
  } catch (e) {
    console.error(e);
  }
}

function popRedirectData() {
  const data = getRedirectData();
  if (data) {
    Cookies.remove('redirect_data');
    return data;
  }
}

const AppCookies = {
  getRedirectData,
  popRedirectData,
};

export default AppCookies;
